import { Box, Divider, HStack, IconButton, Input, InputGroup, InputRightElement, Select, Text, VStack } from "@chakra-ui/react";
import { CalendarTodayOutlined, Close, Upload } from "@mui/icons-material";
import React, { forwardRef } from "react";
import DatePicker from "react-datepicker";
import FileIcon from "../../../components/FileIcon";
import "react-datepicker/dist/react-datepicker.css";


const TaskDetails = ({
    taskName, setTaskName,
    date, setDate,
    taskType, setTaskType,
    taskValue, setTaskValue,
    timezone, setTimezone,
    time, setTime,
    selectedFile, setSelectedFile,
    documentType, setDocumentType,
    currency, setCurrency,
}) => {
    const [isDragging, setIsDragging] = React.useState(false);

    return (
        <VStack
            align={"start"}
            gap={0}
            w={"100%"}
            maxW={"100%"}
        >
            <Text
                lineHeight={"24px"}
                fontSize={"14px"}
                fontWeight={600}
                color={"#333333"}
            >
                Task name
            </Text>
            <Input
                placeholder="Enter task name"
                size="lg"
                fontSize={"14px"}
                width={"100%"}
                height={"48px"}
                marginTop={"8px"}
                value={taskName}
                paddingX={"16px"}
                paddingY={"12px"}
                onChange={(e) => setTaskName(e.target.value)}
                _placeholder={{ color: "#A0A0A0" }}
            />
            <Text
                marginTop={"24px"}
                lineHeight={"24px"}
                fontSize={"14px"}
                fontWeight={600}
                color={"#333333"}
            >
                Task type
            </Text>
            <Select
                size="lg"
                width={"100%"}
                height={"48px"}
                marginTop={"16px"}
                onChange={(e) => setTaskType(e.target.value)}
                fontSize={"14px"}
                color={taskType ? "#1D1D1D" : "#6B7C93"}
                _focusVisible={{ color: "#1D1D1D"}}
            >
                <option value="RFP">RFP</option>
            </Select>
            <Text
                marginTop={"24px"}
                lineHeight={"24px"}
                fontSize={"14px"}
                fontWeight={600}
                color={"#333333"}
            >
                Task value (Optional)
            </Text>
            <HStack
                width={"100%"}
                maxW={"100%"}
                gap={"8px"}
                marginTop={"16px"}
                height={"48px"}
            >
                <Input
                    type="number"
                    placeholder="0"
                    size="lg"
                    fontSize={"14px"}
                    width={"30%"}
                    value={taskValue}
                    paddingX={"16px"}
                    paddingY={"12px"}
                    onChange={(e) => setTaskValue(e.target.value)}
                    _placeholder={{ color: "#A0A0A0" }}
                />
                <Select
                    placeholder="Select currency"
                    size="lg"
                    width={"30%"}
                    onChange={(e) => setCurrency(e.target.value)}
                    fontSize={"14px"}
                    color={currency ? "#1D1D1D" : "#6B7C93"}
                    _focusVisible={{ color: "#1D1D1D"}}
                >
                    <option value="USD">USD</option>
                    <option value="EUR">EUR</option>
                    <option value="INR">INR</option>
                    <option value="GBP">GBP</option>
                    <option value="JPY">JPY</option>
                    <option value="CAD">CAD</option>
                </Select>
            </HStack>
            <Text
                marginTop={"24px"}
                lineHeight={"24px"}
                fontSize={"14px"}
                fontWeight={600}
                color={"#333333"}
            >
                Deadline
            </Text>
            <HStack
                width={"100%"}
            >
                <Box width="100%" marginTop="16px">
                    <DatePicker
                        selected={date}
                        onChange={(newDate) => setDate(newDate)}
                        placeholderText="Select date"
                        customInput={<CustomDateInput />}
                    />
                </Box>
                <Input
                    type="time"
                    size="lg"
                    width={"100%"}
                    height={"48px"}
                    marginTop={"16px"}
                    onChange={(e) => setTime(e.target.value)}
                    value={time}
                    _placeholder={{ color: "#A0A0A0" }}
                />
                <Select
                    placeholder="Select timezone"
                    size="lg"
                    fontSize={"14px"}
                    width={"100%"}
                    height={"48px"}
                    marginTop={"16px"}
                    onChange={(e) => setTimezone(e.target.value)}
                    color={timezone ? "#1D1D1D" : "#6B7C93"}
                    _focusVisible={{ color: "#1D1D1D"}}
                >
                    <option value="UTC">UTC</option>
                    <option value="PST">PST</option>
                    <option value="EST">EST</option>
                    <option value="CET">CET</option>
                    <option value="IST">IST</option>
                    <option value="JST">JST</option>
                </Select>
            </HStack>
            <Divider marginTop={"24px"}/>
            {
                selectedFile ? (
                    <VStack
                        marginTop={"24px"}
                        w={"100%"}
                        maxW={"100%"}
                    >
                        <HStack
                            gap={"8px"}
                            w={"100%"}
                            maxW={"100%"}
                        >
                            <HStack
                                maxWidth={`calc(100% - 8px - 223px)`}
                                height={"40px"}
                                backgroundColor={"#F6FAFF"}
                                padding={"8px"}
                                gap={"8px"}
                                display={"flex"}
                                justify={"space-between"}
                                borderRadius={"8px"}
                            >
                                <FileIcon
                                    fileExtension={
                                        selectedFile?.name?.split('.').reverse()[0]
                                    }
                                    size="xl"
                                />
                                <Text
                                    fontSize={"14px"}
                                    fontWeight={"regular"}
                                    isTruncated
                                >
                                    {selectedFile?.name}
                                </Text>
                                <IconButton
                                    sx={{ 
                                        backgroundColor: "transparent", 
                                        color: "#5D5D5D",
                                        _hover: {
                                            backgroundColor: "transparent",
                                        }
                                    }}
                                    onClick={() => {
                                        setSelectedFile(null);
                                    }}
                                >
                                    <Close
                                        sx={{
                                            fontSize: 16,
                                            color: "#5D5D5D",
                                            "&:hover": {
                                                cursor: "pointer",
                                            },
                                        }}
                                    />
                                </IconButton>
                            </HStack>
                            <Select
                                placeholder="Select document type"
                                size="lg"
                                fontSize={"14px"}
                                width={"223px"}
                                minW={"223px"}
                                height={"40px"}
                                border={"1px solid #ADADAD"}
                                borderRadius={"24px"}
                                onChange={(e) => setDocumentType(e.target.value)}
                                color={documentType ? "#1D1D1D" : "#6B7C93"}
                                _focusVisible={{ color: "#1D1D1D"}}
                            >
                                <option value="work item">Work item</option>
                                <option value="supporting document">Supporting document</option>
                            </Select>
                        </HStack>
                        <Box
                            marginTop={"8px"}
                            height={"68px"}
                            backgroundColor={"#F6FAFF"}
                            borderRadius={"8px"}
                            width={"652px"}
                            paddingY={"16px"}
                            paddingX={"186px"}
                            justifyContent={"center"}
                            display={"flex"}
                            flexDirection={"column"}
                            alignItems={"center"}
                            onClick={() => {
                                console.log("[TaskDetails] Button is clicked")
                                const input = document.createElement('input');
                                input.type = 'file';
                                input.onchange = (event) => {
                                    const file = event.target.files[0];
                                    if (file) {
                                        setSelectedFile(file);
                                    }
                                };
                                input.click();
                            }}
                            onDragOver={(e) => {
                                e.preventDefault();
                                setIsDragging(true);
                            }}
                            onDragLeave={() => setIsDragging(false)}
                            onDrop={(e) => {
                                e.preventDefault();
                                const file = e.dataTransfer.files[0];
                                setSelectedFile(file);
                                setIsDragging(false);
                            }}
                            _hover={{
                                cursor: "pointer",
                            }}
                            border={isDragging ? "1px solid #2584FD" : "none"}
                        >
                            <Upload
                                sx={{ fontSize: 16, color: "#5D5D5D" }}
                            />
                            <HStack
                                gap={"4px"}
                                lineHeight={"24px"}
                            >
                                <Text
                                    marginTop={"4px"}
                                    color={"#1d1d1d"}
                                    fontSize={"14px"}
                                >
                                    Drag and drop or
                                </Text>
                                <Text
                                    marginTop={"4px"}
                                    color={"#2584FD"}
                                    fontSize={"14px"}
                                >
                                    browse file
                                </Text>
                                <Text
                                    marginTop={"4px"}
                                    color={"#1d1d1d"}
                                    fontSize={"14px"}
                                >
                                    to change file
                                </Text>
                            </HStack>
                        </Box>
                    </VStack>
                ) : (
                    <Box
                        marginTop={"24px"}
                        height={"108px"}
                        backgroundColor={"#F6FAFF"}
                        borderRadius={"8px"}
                        width={"642px"}
                        paddingY={"16px"}
                        paddingX={"186px"}
                        justifyContent={"center"}
                        display={"flex"}
                        flexDirection={"column"}
                        alignItems={"center"}
                        onClick={() => {
                            console.log("[TaskDetails] button clicked")
                            const input = document.createElement('input');
                            input.type = 'file';
                            input.onchange = (event) => {
                                const file = event.target.files[0];
                                if (file) {
                                    setSelectedFile(file);
                                }
                            };
                            input.click();
                        }}
                        onDragOver={(e) => {
                            e.preventDefault();
                            setIsDragging(true);
                        }}
                        onDragLeave={() => setIsDragging(false)}
                        onDrop={(e) => {
                            e.preventDefault();
                            const file = e.dataTransfer.files[0];
                            setSelectedFile(file);
                            setIsDragging(false);
                        }}
                        _hover={{
                            cursor: "pointer",
                        }}
                        border={isDragging ? "1px solid #2584FD" : "none"}
                    >
                        <Upload
                            sx={{ fontSize: 16, color: "#5D5D5D" }}
                        />
                        <HStack
                            gap={"4px"}
                            lineHeight={"24px"}
                        >
                            <Text
                                marginTop={"4px"}
                                color={"#1d1d1d"}
                                fontSize={"14px"}
                            >
                                Drag and drop or
                            </Text>
                            <Text
                                marginTop={"4px"}
                                color={"#2584FD"}
                                fontSize={"14px"}
                            >
                                browse file
                            </Text>
                            <Text
                                marginTop={"4px"}
                                color={"#1d1d1d"}
                                fontSize={"14px"}
                            >
                                to upload
                            </Text>
                        </HStack>
                        <Text
                            lineHeight={"24px"}
                            fontSize={"12px"}
                        >
                            pdf, docx, png, jpeg, jpg, xlsx, csv, pptx, txt, zip
                        </Text>
                    </Box>
                )
            }
        </VStack>
    )
}

const CustomDateInput = forwardRef(({ value, onClick, placeholder }, ref) => (
    <InputGroup size="lg">
      <Input
        ref={ref}
        value={value}
        onClick={onClick}
        placeholder={placeholder}
        height="48px"
        _placeholder={{ color: "#6B7C93", fontSize: "14px" }}
        readOnly
      />
      <InputRightElement height="48px" pointerEvents="none">
        <CalendarTodayOutlined
            sx={{ fontSize: 22, color: "#5D5D5D" }}
        />
      </InputRightElement>
    </InputGroup>
));

export default TaskDetails;